export default Object.freeze({
  Created: 1,
  Pending: 2,
  Completed: 3,
  Cancelled: 4,
  Failed: 5,
  Expired: 6,
});
